import { render, staticRenderFns } from "./MyIndex.vue?vue&type=template&id=a6b54e9c&scoped=true&"
import script from "./MyIndex.vue?vue&type=script&lang=js&"
export * from "./MyIndex.vue?vue&type=script&lang=js&"
import style0 from "./MyIndex.vue?vue&type=style&index=0&id=a6b54e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b54e9c",
  null
  
)

export default component.exports